import { useOktaAuth } from "@okta/okta-react";
import { useState } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ReactPhoneInput from "react-phone-input-2";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import ReactLoading from "react-loading";

function Home() {
    let employeeDiscountId, oktaId;
    const { oktaAuth, authState } = useOktaAuth();
    const [isLoading, setLoading] = useState(false);
    const [isApplied, setApplied] = useState(employeeDiscountId ? true : false);
    const [isError, setError] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [emailInputVal, setEmailInputVal] = useState('')
    const [phoneInputVal, setPhoneInputVal] = useState('+1')
    const [alignment, setAlignment] = useState();
    const { control, handleSubmit } = useForm();
    const validEmail = new RegExp("^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$");
    const validPhone = new RegExp("^[\+]?[0-9]?[-\s]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$");

    const handleToggleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    };

    const onSubmit = (data) => {
        if (alignment === "phone") {
            if (!validPhone.test(data.phone)) {
                alert("Please enter a valid phone number");
            }
            else {
                assignEmployeeDiscount(null, "+" + data.phone, oktaId);
            }
        } else if (alignment === "email") {
            if (!validEmail.test(data.email)) {
                alert("Please enter a valid email address");
            }
            else {
                assignEmployeeDiscount(data.email, null, oktaId);
            }
        }
    };

    const login = async () => oktaAuth.signInWithRedirect();
    const logout = async () => oktaAuth.signOut("/");
    //const delay = ms => new Promise(res => setTimeout(res, ms));

    async function assignEmployeeDiscount(emailValue, numberValue, oktaId) {
        try {
            const pipelineRequest = await axios.post(`https://unmanaged-app-unassignment.it-ops.gopuff.dev/assignBOEmployeeDiscount`, {
                activeEmployee: true,
                discountApplierId: oktaId,
                emailAddress: emailValue,
                phoneNumber: numberValue
            });

            if (pipelineRequest.data) {
                if (pipelineRequest.data.status) {
                    if (pipelineRequest.data.status === "Discount already Applied") {
                        setApplied(true);
                    } else if (pipelineRequest.data.status === "User not found") {
                        setNotFound(true);
                    } else{
                        setApplied(true);
                    }
                }
                else {
                    setApplied(true);
                }
            }
            else {
                setError(true);
            }
        } catch (error) {
            console.error(error);
        }
    }

    if (authState != null) {
        if (authState.accessToken != null) {
            employeeDiscountId = authState.accessToken.claims.empDiscountID
            oktaId = authState.accessToken.claims.uid
            if (employeeDiscountId) {
                return (
                    <div className="App">
                        <main role="main" className="container">
                            <nav className="navbar navbar-expand-lg navbar-light bg-light ">
                                <ul className="nav navbar-nav ml-auto navbar-right ms-auto">
                                    <li>
                                        {authState?.isAuthenticated && (
                                            <button className="btn" onClick={logout}>
                                                Logout
                                            </button>
                                        )}

                                        {!authState?.isAuthenticated && (
                                            <button className="btn" onClick={login}>
                                                Login
                                            </button>
                                        )}
                                    </li>
                                </ul>
                            </nav>

                            <h1 className="cover-heading">Your employee discount has already been applied.</h1>
                        </main>
                    </div>
                )
            }
        }
    }

    return (
        <div className="App">
            {/*isLoading ?
                <div className="container">
                    <ReactLoading type="spokes" color="#119fee"
                        height={100} width={50} style={{ float: "center" }} />
                </div>
                :
                */
                notFound ?
                    <main role="main" className="container">
                        <nav className="navbar navbar-expand-lg navbar-light bg-light ">
                            <ul className="nav navbar-nav ml-auto navbar-right ms-auto">
                                <li>
                                    {authState?.isAuthenticated && (
                                        <button className="btn" onClick={logout}>
                                            Logout
                                        </button>
                                    )}

                                    {!authState?.isAuthenticated && (
                                        <button className="btn" onClick={login}>
                                            Login
                                        </button>
                                    )}
                                </li>
                            </ul>
                        </nav>

                        <h1 className="cover-heading">It looks like the information you entered is not associated with a Gopuff customer account yet. Head to <a href="https://gopuff.com">gopuff.com</a>, create your account, and then come back to apply your discount.</h1>
                    </main>
                    :
                    isApplied ?
                        <main role="main" className="container">
                            <nav className="navbar navbar-expand-lg navbar-light bg-light ">
                                <ul className="nav navbar-nav ml-auto navbar-right ms-auto">
                                    <li>
                                        {authState?.isAuthenticated && (
                                            <button className="btn" onClick={logout}>
                                                Logout
                                            </button>
                                        )}

                                        {!authState?.isAuthenticated && (
                                            <button className="btn" onClick={login}>
                                                Login
                                            </button>
                                        )}
                                    </li>
                                </ul>
                            </nav>

                            <h1 className="cover-heading">Your employee discount has successfully been applied!</h1>
                        </main>
                        :
                        isError ?
                            <main role="main" className="container">
                                <nav className="navbar navbar-expand-lg navbar-light bg-light ">
                                    <ul className="nav navbar-nav ml-auto navbar-right ms-auto">
                                        <li>
                                            {authState?.isAuthenticated && (
                                                <button className="btn" onClick={logout}>
                                                    Logout
                                                </button>
                                            )}

                                            {!authState?.isAuthenticated && (
                                                <button className="btn" onClick={login}>
                                                    Login
                                                </button>
                                            )}
                                        </li>
                                    </ul>
                                </nav>

                                <h1 className="cover-heading">An error occurred applying your employee discount, please logout and log back in to retry.</h1>
                            </main>
                            :
                            <main role="main" className="container">
                                <nav className="navbar navbar-expand-lg navbar-light bg-light ">
                                    <ul className="nav navbar-nav ml-auto navbar-right ms-auto">
                                        <li>
                                            {authState?.isAuthenticated && (
                                                <button className="btn" onClick={logout}>
                                                    Logout
                                                </button>
                                            )}

                                            {!authState?.isAuthenticated && (
                                                <button className="btn" onClick={login}>
                                                    Login
                                                </button>
                                            )}
                                        </li>
                                    </ul>
                                </nav>

                                <h1 className="cover-heading">Activate your employee discount!</h1>
                                <br />

                                {!authState?.isAuthenticated && (
                                    <div>
                                        <p className="lead">In order to use this application you must be logged into your Okta account</p>
                                    </div>
                                )}
                                {authState?.isAuthenticated && (
                                    <div>
                                        <h3>
                                        Enter the phone number or email associated with your Gopuff account. If you do not have a Gopuff account, you can create one by visiting <a href="https://gopuff.com">gopuff.com</a>  or downloading the app and following the instructions for signup. We suggest using your personal email and phone number at signup.
                                        </h3>
                                        
                                        <br />
                                        <ToggleButtonGroup
                                            color="primary"
                                            value={alignment}
                                            exclusive
                                            onChange={handleToggleChange}
                                            aria-label="Input Selection"
                                        >
                                            <ToggleButton value="phone">Phone</ToggleButton>
                                            <ToggleButton value="email">Email</ToggleButton>
                                        </ToggleButtonGroup>
                                        <br /><br />
                                        {alignment === "phone" ? (
                                            <form onSubmit={handleSubmit(onSubmit)} value={phoneInputVal} onChange={e => setPhoneInputVal(e.target.value)}>
                                                <Controller
                                                    control={control}
                                                    name="phone"
                                                    rules={{ required: true }}
                                                    render={({ field: { ref, ...phone } }) => (
                                                        <ReactPhoneInput
                                                            {...phone}
                                                            inputExtraProps={{
                                                                ref,
                                                                required: true,
                                                                autoFocus: true
                                                            }}
                                                            country={"us"}
                                                            onlyCountries={["us", "gb"]}
                                                            specialLabel={"Phone Number"}
                                                            containerClass="center"
                                                        />
                                                    )}
                                                />
                                                <input type="submit" className="btn" style={{ width: "auto" }} disabled={phoneInputVal.length <= 14} />
                                            </form>
                                        ) : alignment === "email" ? (
                                            <form onSubmit={handleSubmit(onSubmit)} value={emailInputVal} onChange={e => setEmailInputVal(e.target.value)}>
                                                <Controller
                                                    control={control}
                                                    name="email"
                                                    rules={{ required: true }}
                                                    render={({ field: { ref, ...email } }) => (
                                                        <div className="center">
                                                            <input
                                                                {...email}
                                                                type="text"
                                                                id="email-input"
                                                                placeholder="Enter email address"
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                <input type="submit" className="btn" style={{ width: "auto" }} disabled={!validEmail.test(emailInputVal)} />
                                            </form>
                                        ) : null}
                                    </div>
                                )}
                            </main>
            }
        </div>
    );
}

export default Home;